module.exports = __webpack_public_path__ + "static/img/BG.15923c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeimg/BG.png
// module id = coi+
// module chunks = 1